/**
 * User: Rob Richard
 * Date: 12/3/14
 * Time: 6:30 PM
 */

'use strict';

var SoaCollection = require('bunsen/collections/SoaCollection');
var Promotions = module.exports = SoaCollection.extend();

var _ = require('underscore');
var Promotion = require('bunsen/models/ecomm/Promotion');
var findByFn = function (fn) {
    return this.find(function (promo) {
        return promo[fn]();
    });
};

_.extend(Promotions.prototype, {
    model: Promotion,
    getActivePromo: _.partial(findByFn, 'isActive'),
    getInvalidPromo: _.partial(findByFn, 'isInvalid')
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/ecomm/Promotions.js
// module id = 163
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56